/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {OutlookConfig} from "../model/outlook-config";
import {OutlookUser} from "../model/outlook-user";
import {UpdateCalendarSyncToUserRequest} from "../model/update-calendar-sync-to-user-request";

@Injectable({
    providedIn: "root",
})
export class SimOutlookSyncService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Returns the connection state of the underlying client Internally, this means the GraphClient has been initialized successfully
 */ 

    public checkConnection() {
        return super.get<boolean>(`/api/OutlookSync/CheckConnection`, );
    }
/**
 * Checks if calendar synchronization is working
 */ 

    public checkSynchronization() {
        return super.get<boolean>(`/api/OutlookSync/CheckSynchronization`, );
    }
/**
 * Returns the combined connection configuration and client configuration
 */ 

    public getOutlookConfiguration() {
        return super.get<OutlookConfig>(`/api/OutlookSync/GetOutlookConfiguration`, );
    }
/**
 * Searches a user by userName, email or id
 */ 

    public searchUser(userName: string, email: string, id: string) {
        return super.get<OutlookUser>(`/api/OutlookSync/SearchUser`, {userName: userName, email: email, id: id});
    }
/**
 * Updates the calendar sync to the specified user's default calendar
 */ 

    public updateCalendarSyncToUser(request: UpdateCalendarSyncToUserRequest) {
        return super.post<boolean>(`/api/OutlookSync/UpdateCalendarSyncToUser`, request);
    }
}